import fetchAPI from '../../fetchAPI';

export const callStartSyncCoreContacts = async (
  locationId: string,
  daysBack?: number
): Promise<iResponse<{ jobId: string; status: string }>> => {
  const queryString =
    daysBack != null ? `daysBack=${daysBack}` : undefined;
  const response = await fetchAPI<{ jobId: string; status: string }>({
    method: 'POST',
    route: `core/location/${locationId}/sync-contacts`,
    queryString
  });
  return response;
};

export default callStartSyncCoreContacts;
